import axios from 'axios';
import { ADD_CATEGORY } from '../../../constants';

export const createCategory = (data, onError, onNewClose) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(addCategory());
  axios
    .post(`/jobs/createCategory`, data, config)
    .then((res) => {
      onNewClose();
      dispatch(setAddCategory(res));
    })
    .catch((err) => {
      dispatch(errorAddCategory(err.response));
      onError(err.response);
    });
};

export const addCategory = () => ({
  type: ADD_CATEGORY.LOAD,
});

export const setAddCategory = (data) => ({
  type: ADD_CATEGORY.SUCCESS,
  payload: data.data,
});

export const errorAddCategory = (error) => ({
  type: ADD_CATEGORY.FAIL,
  payload: error,
});
